// ---------------------------------------------------------------------------------------------------------------
//
import { NgModule, LOCALE_ID, enableProdMode, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { GlobalErrorHandler } from './shared/global-error-handler';
import { APP_BASE_HREF } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { TokenCredentials, WebResource } from '@azure/ms-rest-js';

import { UsersService } from 'iws-users';

import { IWSErrorModule, ErrorHandlerService } from '@iws-ux/error';
import { AuthHelperService, NavigationFilterGuard } from '@iws-ux/auth';
import { DialogService, IWSDialogModule } from '@iws-ux/dialog';
import { IWSProfileEditorModule } from '@iws-ux/profile-editor';
import { IWSHeaderModule } from '@iws-ux/header';
import { IWSLoginModule } from '@iws-ux/login';
import { ToastService } from '@iws-ux/toast';
import { ValidationSummaryService } from '@iws-ux/validation';

// ---------------------------------------------------------------------------------------------------------------

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
//import { StoreDevtoolsModule } from '@ngrx/store-devtools';

// ---------------------------------------------------------------------------------------------------------------
// Services
import { routing } from './app.routing';
import { AppComponent } from './components/app/app.component';
import { ProfileComponent } from './components/app/profile.component';

import { ConfigurationService } from './services/Configuration/Configuration.service';
import { MonitoringService } from './services/Monitoring/Monitoring.service';

import { FileValidator } from './directives/FileValidator.directive';
import { AuthInterceptor } from './shared/auth.interceptor';

// ---------------------------------------------------------------------------------------------------------------
// Providers
const APP_PROVIDERS = [

    {
        provide: APP_BASE_HREF,
        useValue: '/'
    },

    {
        provide: LOCALE_ID,
        useValue: "en-GB"
    },

    {
        provide: 'BASE_URL',
        useValue: "/"
    },

    {
        provide: APP_INITIALIZER,
        useFactory: (configService: ConfigurationService) => () => configService.initialise(),
        deps: [ConfigurationService],
        multi: true
    }
];

const GUARD_PROVIDERS = [
    NavigationFilterGuard
];

const SERVICE_PROVIDERS = [
    ConfigurationService,
    ErrorHandlerService,
    MonitoringService,
    DialogService,
    ValidationSummaryService,
    ToastService,
    AuthHelperService
];

const API_PROVIDERS = [
    {
        provide: UsersService,
        useFactory: (configService: ConfigurationService, oauthService: OAuthService) => {
            return new UsersService({
                signRequest(webResource: WebResource): Promise<WebResource> {
                    var token = new TokenCredentials(oauthService.getAccessToken());
                    return token.signRequest(webResource);
                }
            }, {
                baseUri: configService.config.identityEndpoint,
                noRetryPolicy: true
            });
        },
        deps: [ConfigurationService, OAuthService],
        multi: false
    },

    //    {
    //        provide: () => ProgressService,
    //        useFactory: (configService: ConfigurationService, oauthService: OAuthService) => {
    //            return () => new ProgressService(oauthService, configService.config.runnerEndpoint);
    //        },
    //        deps: [ConfigurationService, OAuthService],
    //        multi: false
    //    }
];

// ---------------------------------------------------------------------------------------------------------------
@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        OAuthModule.forRoot(),
        IWSErrorModule,
        IWSDialogModule,
        IWSProfileEditorModule,
        IWSHeaderModule,
        IWSLoginModule,
        routing,

        StoreModule.forRoot({}),
        //      StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
        EffectsModule.forRoot([])
    ],

    declarations: [
        AppComponent,
        ProfileComponent,
        FileValidator
    ],

    providers: [
        Title,
        APP_PROVIDERS,
        GUARD_PROVIDERS,
        SERVICE_PROVIDERS,
        API_PROVIDERS,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: ErrorHandler, useClass: GlobalErrorHandler }
    ],
    bootstrap: [
        AppComponent
    ]
})

// ---------------------------------------------------------------------------------------------------------------
export class AppModule { }